import {StudentProfile} from 'grpc-bob/student_pb';
import {Order, Plan} from 'grpc-bob/subscription_pb';

import {
  AppActions,
  IPromotion,
  PackageWithPromotion,
  SET_CHOSEN_PACKAGE,
  SET_LOADING,
  SET_MESSAGE,
  SET_ORDER_WAITING_PAYMENT,
  SET_ORDERS,
  SET_PACKAGES,
  SET_PARTIAL_STATE,
  SET_PAYMENT_ORDER_ID,
  // SET_PAYMENT_URL,
  SET_PLAN_ID,
  SET_PLANS,
  SET_PROMOTION,
  SET_PROMOTION_EFFECT,
  SET_SUMMARY,
  SET_TOKEN,
  SET_USER
} from './types';
import {findActiveOrder} from '../../utils';
import {PROMOTION_STATUS} from '../../constants/enum';


export interface AppState {
  loading: boolean
  paymentLoading: boolean
  token: string | null
  planId: string | null
  plans: Plan.AsObject[]
  packages: PackageWithPromotion[],
  user: StudentProfile.AsObject | undefined //undefined for more convenient type-safe with backend generated proto
  chosenPackage: PackageWithPromotion | null
  orderSummary: Order.AsObject | null
  orderWaitingPayment: Order.AsObject | null
  activeOrder: Order.AsObject | null
  orders: Order.AsObject[]
  message: string
  promotion: IPromotion,
  paymentOrderId: number | null
  //paymentUrl: string
}

export const initialState: AppState = {
  loading: true,
  paymentLoading: true,
  token: null,
  planId: null,
  plans: [],
  packages: [],
  message: '',
  user: undefined,
  chosenPackage: null,
  orderSummary: null,
  orderWaitingPayment: null,
  activeOrder: null,
  orders: [],
  promotion: {
    text: '',
    status: PROMOTION_STATUS.UNDETERMINED,
    err: ''
  },
  paymentOrderId: null,
 // paymentUrl: ''
};


function reducer(state: AppState, action: AppActions): AppState {
  switch (action.type) {
    case SET_LOADING:
      return {...state, loading: action.payload};

    case SET_TOKEN:
      return {...state, token: action.payload};

    case SET_PLAN_ID:
      return {...state, planId: action.payload};

    case SET_PACKAGES:
      return {...state, packages: action.payload};

    case SET_PLANS:
      return {...state, plans: action.payload};

    case SET_MESSAGE:
      return {...state, message: action.payload};

    case SET_USER:
      return {...state, user: action.payload};

    case SET_CHOSEN_PACKAGE:
      return {
        ...state,
        chosenPackage: action.payload
      };

    case SET_SUMMARY:
      const {order, user} = action.payload;
      return {...state, orderSummary: order, user};

    case SET_ORDER_WAITING_PAYMENT:
      return {...state, orderWaitingPayment: action.payload};

    case SET_ORDERS:
      const activeOrder = findActiveOrder(action.payload);
      return {...state, activeOrder, orders: action.payload};

    case SET_PROMOTION:
      return {...state, promotion: {...state.promotion, ...action.payload}};

    case SET_PROMOTION_EFFECT:
      return {...state, ...action.payload};

    case SET_PARTIAL_STATE:
      return {...state, ...action.payload};

    case SET_PAYMENT_ORDER_ID:
      return {...state, paymentOrderId: action.payload};

    // case SET_PAYMENT_URL:
    //   return {...state, paymentUrl: action.payload};

    // case SET_INITIAL_DATA:
    //   return {...state, ...action.payload};

    default:
      return state
  }
}

export default reducer
